import React from "react";
import ServicesInfo from "./ServicesInfo";
import WorkProcess from "./WorkProcessBanner";
import Testimonial from "./Testimonial";

const Services = () => {
  return (
    <div>
      <ServicesInfo />
      <WorkProcess />
      <Testimonial />
    </div>
  );
};

export default Services;
